<template>
    <div
       :style="styleObj"
    >
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">

      <div class="row" style="text-align: right">
            <p>
              <u v-if="showFlightOptions" @click="toggleFlightOptions"> Verberg filters</u>
              <u v-else @click="toggleFlightOptions"> Toon filter</u>
            </p>
        </div>
      <div class="row" v-if="showFlightOptions">
        <div class="col-md-3">
          Passagiers
          <div class="row form-control">

              Volwassenen
              <input type="number" v-model="totalAdults" />

              Kinderen (tot 12 jaar)
              <input type="number" v-model="totalKids" />

              Baby (tot 2 jaar)
              <input type="number" v-model="totalInfants" />
            </div>

        </div>
        <div class="col-md-9">
          <div class="row" >
            <div class="col-12">
              <div class="row">
               <div class="col-1"></div>
               <div class="col-11">
                 <div class="row"> <div class="col-3">Vertrekhaven</div>
                   <div class="col-3">Aankomsthaven</div>
                   <div class="col-3">Datum</div>
                   <div class="col-3">Uiterlijke aankomst / vertrek vanaf</div></div>

               </div>

              </div>
            </div>
            <div v-if="airports && airports.length > 0" class="col-12">
              <div class="row">
                <div class="col-1">
                 <input type="text" disabled value="Heen">
                </div>
                <div class="col-11">
                  <div class="row">
                   <div class="col-3">
                     <Dropdown
                         v-if="!loading"
                         :loadSelect="
                            findOutboundDepartAirport
                                ? findOutboundDepartAirport
                                : findOutboundArriveAirport
                        "
                         v-on:selected="setOutboundDepartAirport"
                         :options="airportsFormatted"
                         :disabled="false"
                         :maxItem="1000"
                         placeholder="Kies een luchthaven"
                     />
                     <input v-else type="text" value="Luchthavens laden.." disabled>
                   </div>
                   <div class="col-3">
                     <Dropdown
                         v-if="!loading"
                         :loadSelect="
                                findOutboundArriveAirport
                                    ? findOutboundArriveAirport
                                    : findOutboundDepartAirport
                            "
                         v-on:selected="setOutboundArriveAirport"
                         :options="airportsFormatted"
                         :disabled="false"
                         :maxItem="1000"
                         placeholder="Kies een luchthaven"
                     />
                     <input v-else type="text" value="Luchthavens laden.." disabled>
                   </div>
                   <div class="col-3">
                     <input type="date" v-model="findOutboundArriveDate" />
                   </div>
                   <div class="col-3">
                     <input type="time" v-model="findOutboundArriveTime" /></div>
                  </div>
                </div>
                <hr>
              </div>

            </div>

            <div v-if="airports && airports.length > 0 && payload" class="col-12">
              <div class="row">
                <div class="col-1">
                  <input type="text" value="Terug" disabled>
                </div>
                <div class="col-11">
                  <div class="row">
                    <div class="col-3">  <Dropdown
                        v-if="!loading"
                        v-on:selected="setInboundDepartAirport"
                        :loadSelect="
                                findInboundDepartAirport
                                    ? findInboundDepartAirport
                                    : findInboundArriveAirport
                            "
                        :options="airportsFormatted"
                        :disabled="false"
                        :maxItem="1000"
                        placeholder="Kies een luchthaven"
                    />
                      <input v-else type="text" value="Luchthavens laden.." disabled>
                    </div>
                    <div class="col-3"><Dropdown
                        v-if="!loading"
                        v-on:selected="setInboundArriveAirport"
                        :loadSelect="
                                findInboundArriveAirport
                                    ? findInboundArriveAirport
                                    : findInboundDepartAirport
                            "
                        :options="airportsFormatted"
                        :disabled="false"
                        :maxItem="1000"
                        placeholder="Kies een luchthaven"
                    /><input v-else type="text" value="Luchthavens laden.." disabled></div>
                    <div class="col-3"> <input type="date" v-model="findInboundDepartDate" /></div>
                    <div class="col-3"><input
                        id="findInboundDepartTime"
                        type="time"
                        v-model="findInboundDepartTime"
                    /></div>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-12">
              <hr>
              <div class="row">
                <div class="col-3">
                  <input
                      type="checkbox"
                      id="nonStopOnly"
                      v-model="nonStopOnly"
                      :disabled="waiting"
                  />
                  <label for="nonstopOnly"
                  >Alleen Directe vluchten (NonStop)</label
                  >
                </div>
                <div class="col-3">
                  <label for="flightClass">Class</label>
                  <div class="select-drop">
                    <select
                        id="flightClass"
                        v-model="flightClass"
                        :disabled="waiting"
                    >
                      <option value="Economy">Economy</option>
                      <option value="Business">Business</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <hr>
      <div v-if="!waiting" class="row1" style="margin-top:20px;margin-bottom:20px">
        <button v-on:click="getflights" class="button">
          Vind vluchten
        </button>
      </div>
      <div class="row" v-if="showFlightOptions && !waiting">



            <div class="col-3">   <label for="minWaiting">Min. Transit</label>
              <input type="number" id="minWaiting" v-model="minWaiting" /></div>
            <div class="col-3"> <label for="maxWaiting">Max. Transit</label>
              <input type="number" id="maxWaiting" v-model="maxWaiting" /> </div>
            <div class="col-3">

              <label for="findCarrier">Carrier</label>
              <select
                  id="findCarrier"
                  v-model="findCarrier"
                  :disabled="waiting"
              >
                <option value="">Geen carrier</option>
                <option
                    v-for="(carrier, index) in availableFlightCarriers"
                    :key="'FindCarrierSelect' + index"
                    :value="carrier.Code"
                >
                  {{ carrier.DisplayName }}
                </option>
              </select>
            </div>
        <div class="col-3">

              <label for="findRate">Tarief</label>

              <select
                  id="findRate"
                  v-model="findRate"
                  :disabled="waiting"
              >
                {{availableRatesFlights}}
                <option value="">Alle tarieven</option>
                <option
                    v-for="(rate, index) in availableRatesFlights"
                    :key="'FindRateSelect' + index"
                    :value="rate"
                >
                  {{ rate }}
                </option>
              </select>
            </div>

        <hr>
          </div>


      <div class="row1" v-if="showFlightOptions">
        <div class="width20 d-none">
          <input
              type="checkbox"
              id="seekDatabase"
              v-model="seekDatabase"
              :disabled="waiting"
          />
          <label for="seekDatabase">Zoek in opgeslagen resultaten</label>
        </div>
        <div class="width20 d-none">
          <input
              type="checkbox"
              id="seekAirTrade"
              v-model="seekAirTrade"
              :disabled="waiting"
          />
          <label for="seekAirTrade">Zoek via Airtrade</label>
        </div>
        <div class="width20 d-none">
          <input
              type="checkbox"
              id="seekTransavia"
              v-model="seekTransavia"
              :disabled="waiting"
          />
          <label for="seekTransavia">Zoek via Transavia</label>
        </div>

        <div class="width20 d-none">
          <input
              type="checkbox"
              id="seekAmadeus"
              :disabled="false"
              v-model="seekAmadeus"
          />

          <label for="seekAmadeus">Zoek via Amadeus</label>
        </div>
      </div>

        <div class="row1">
            <div
                v-if="selectedFlight && !isHidden && selectedFlight.inbound[0].airline.Code === 'KL' && selectedFlight.outbound[0].airline.Code === 'KL' && !waitingForBaggage && baggageOptions === ''"
                class="groot-button orange"
                v-on:click="checkFareOptionsForFlights"
            >
                Bekijk beschikbare tarieven
            </div>
          <div v-else-if="selectedFlight && !isHidden && selectedFlight.inbound[0].airline.Code === 'KL' && selectedFlight.outbound[0].airline.Code === 'KL' && waitingForBaggage"  class="groot-button orange">
            Aan het laden...   <font-awesome-icon icon="spinner" :spin="true" />
          </div>
          <div v-else-if="selectedFlight && !isHidden && selectedFlight.inbound[0].airline.Code === 'KL' && selectedFlight.outbound[0].airline.Code === 'KL' && baggageOptions !== ''" style="width: 100%;margin-bottom: 10px">

            <div v-if="baggageOptions.FareOptions" style="display: flex; flex-flow: row; width: 100%; justify-content: center">
              <div v-for="fareOption in (baggageOptions.FareOptions)" style="border-bottom: 1px solid grey"  v-on:click="selectFlightWithFares(fareOption)">
                <b>{{ fareOption.ProviderFareCode}}  {{ fareOption.AirtradeFareCode}}</b><br>
                Totaal: &euro;  {{ fareOption.Price.Total }}<br>
                <div v-for="service in (fareOption.Services)">
                  <p :class="{ green: service.Included, red: !service.Included }" style="margin:0">-  {{ service.DisplayName }} {{ service.ProviderDescription }} </p>
                </div>
              </div>
              </div>
          </div>

          <div
                v-else-if="selectedFlight && !isHidden"
                class="groot-button orange"
                v-on:click="addFlightsToDossier"
            >
                Voeg vluchten toe aan dossier
            </div>
            <div class="flightsadded" v-if="isHidden">
                ✓ Vluchten toegevoegd
            </div>
        </div>
        <div v-if="!waiting && flights && flights.length > 0" class="flights">
            <center>
                Er worden <b>{{ filterFlightCarriers.length }}</b> van de
                <b>{{ flights.length }}</b> resultaten getoond.   <input
                type="checkbox"
                v-on:change="toggleFilter"
                :disabled="waiting"
            />
              <label>Filter uitschakelen</label>
            </center>
            <div
                class="row1"
                style="border-bottom: 1px solid black; font-weight: bold;"
            >
                <div class="item">
                    Heenvlucht
                </div>
                <div class="item">
                    Terugvlucht
                </div>
                <div class="item prijs">
                    Prijs
                </div>
                <div class="item prijs"></div>
            </div>
            <FlightFinderResult
                class="row1"
                style="border-bottom: 1px solid black;"
                v-for="(result, index) in filterFlightCarriers"
                :key="'flightResult' + index"
                :result="result"
                :index="index"
                :selectedFlight="selectedFlight"
                :selectedIndex="selectedIndex"
                :findOutboundArriveDate="findOutboundArriveDate"
                :findOutboundArriveTime="findOutboundArriveTime"
                :findInboundDepartDate="findInboundDepartDate"
                :findInboundDepartTime="findInboundDepartTime"
                :findCarrier="findCarrier"
                :findRate="findRate"
                @selectFlight="selectFlight"
            />
        </div>

        <div
            v-else-if="waiting && !loading"
            class="row1 paddingleft15 paddingright15 paddingtop20"
            style="text-align: center; font-size:50px;"
        >
            <font-awesome-icon icon="spinner" :spin="true" />
        </div>

        <div
            v-else-if="!waiting"
            class="row1 paddingleft15 paddingright15 paddingtop20"
            style="text-align: center;"
        >
            Geen resultaten...
        </div>

        <div v-if="response.error">
            <div
                class="row1"
                style="text-align: center;"
                v-for="(msg, index) in response.messages"
                :key="'ResponseMessages' + index"
                v-html="msg"
            ></div>
        </div>
        <div class="row1">
            <div
                v-if="selectedFlight && !isHidden"
                class="groot-button orange"
                v-on:click="addFlightsToDossier"
            >
                Voeg vluchten toe aan dossier
            </div>
        </div>
    </div>
</template>

<script>
import FlightFinderResult from './components/FlightFinderResult.vue'
import Dropdown from './components/Dropdown.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

library.add(faSpinner)

export default {
    name: 'FlightFinder.vue',
    data: function() {
        return {
            findOutboundDepartAirport: null,
            findOutboundArriveAirport: null,
            findOutboundArriveDate: null,
            findOutboundArriveTime: null,

            findInboundDepartAirport: null,
            findInboundArriveAirport: null,
            findInboundDepartTime: null,
            findInboundDepartDate: null,
            filterEnabled: true,
            findCarrier: '',
            findRate: '',

            returnAirports: true,
            returnAllAirports: false,
            seekDatabase: false,
            seekTransavia: false,
            seekAirTrade: true,
            seekAmadeus: false,
            nonStopOnly: true,
            flightClass: 'Economy',

            minWaiting: '2',
            maxWaiting: '4',
            selectedIndex: null,
            selectedFlight: null,
            isHidden: false,
            loading: true,
            showFlightOptions: true,

            totalAdults: null,
            totalKids: null,
            totalInfants: null,
           waitingForBaggage: false,
          baggageOptions: String,

        }
    },
    components: {
        FlightFinderResult,
        Dropdown,
    },
    computed: {
        payload: function() {
            return this.$store.state.payload
        },

        waiting: function() {
            return this.$store.state.waiting
        },

        flights: function() {
            return this.$store.state.flights
        },


        filterFlightCarriers: function() {
            let filter = this.filterEnabled
            if (filter) {
                let dataFlight = {
                    flights: this.filterFlightTime,
                    findCarrier: this.findCarrier,
                }
                return this.$store.getters.filterFlightsCarrier(dataFlight)
            }
            return this.flights
        },


        filterFlightTime: function() {
            const inboundOnly =
                this.findOutboundDepartAirport === 'no' &&
                !this.findOutboundArriveAirport === 'no'
            const outboundOnly =
                this.findInboundDepartAirport === 'no' &&
                this.findInboundArriveAirport === 'no'

            const flightObj = {
                flights: this.filterFlightTransit,
                findOutboundArriveDate: this.findOutboundArriveDate,
                findOutboundArriveTime: this.findOutboundArriveTime,
                findInboundDepartDate: this.findInboundDepartDate,
                findInboundDepartTime: this.findInboundDepartTime,
                outboundOnly,
                inboundOnly,
            }

            return this.$store.getters.filterFlightsTime(flightObj)
        },

        filterFlightTransit: function() {
            const outboundOnly =
                this.findOutboundDepartAirport === 'no' &&
                !this.findOutboundArriveAirport === 'no'
            const inboundOnly =
                this.findInboundDepartAirport === 'no' &&
                this.findInboundArriveAirport === 'no'

            const dataFlight = {
                flights: this.filterFlightRates,
                minWaiting: this.minWaiting,
                maxWaiting: this.maxWaiting,
                outboundOnly,
                inboundOnly,
            }

            return this.$store.getters.filterFlightsTransit(dataFlight)
        },

      filterFlightRates: function() {
        let filter = this.filterEnabled
        if (filter) {
          let dataFlight = {
            flights: this.flights,
            findRate: this.findRate,
          }
          return this.$store.getters.filterFlightsRate(dataFlight)
        }
        return this.flights
      },

        ajaxCalls: function() {
            return this.$store.state.ajaxCalls
        },

        cruise: function() {
            return this.$store.state.cruise
        },

        response: function() {
            return this.$store.state.response
        },

        airportsFormatted: function() {
            //This provides correct data for the dropdown component
            const airports = this.$store.state.airports
            let data = []
            data.push({
                id: 'no',
                name: 'Geen luchthaven',
                airport: {
                    name: 'Geen luchthaven',
                    iata_code: 'no',
                    transfermarge: 0,
                },
            })
            airports.map(airport => {
                const name = airport.name.replace(/[()]/g, '')
                data.push({
                    id: airport.name,
                    name:
                        name +
                        ' <' +
                        airport.iata_code +
                        '> - ' +
                        airport.alias,
                    airport,
                })
            })
            return data
        },

        airports: function() {
            return this.$store.state.airports
        },

        availableFlightCarriers: function() {
            return this.$store.state.availableFlightCarriers
        },

      availableRatesFlights: function() {
            return this.$store.state.availableRatesFlights
        },
      styleObj: function() {
        return {
          'overflow-y': 'auto',
          'overflow-x': 'hidden',
          margin: '10px',
          'max-height' : this.$route.params.backend === 'backend' ? 'initial' : '600px',

        };
      }
    },
    watch: {
        waiting: function(waiting) {
            if (waiting || !this.payload) {
                return
            }
          this.setFlightTotalPax()
            this.findOutboundArriveDate = this.payload.findOutboundArriveDate
            this.findOutboundArriveTime = this.payload.findOutboundArriveTime
            this.findOutboundDepartAirport = this.payload.findOutboundDepartAirport
            this.findOutboundArriveAirport = this.payload.findOutboundArriveAirport

            this.findInboundDepartDate = this.payload.findInboundDepartDate
            this.findInboundDepartTime = this.payload.findInboundDepartTime
            this.findInboundDepartAirport = this.payload.findInboundDepartAirport
            this.findInboundArriveAirport = this.payload.findInboundArriveAirport
            this.loading = false
        },
    },
    methods: {
        setInboundArriveAirport: function(event) {
            if (event.name) {
                this.findInboundArriveAirport = event.airport.iata_code
            }
        },
        setInboundDepartAirport: function(event) {
            if (event.name) {
                this.findInboundDepartAirport = event.airport.iata_code
            }
        },
        setOutboundArriveAirport: function(event) {
            if (event.name) {
                this.findOutboundArriveAirport = event.airport.iata_code
            }
        },
        setOutboundDepartAirport: function(event) {
            if (event.name) {
                this.findOutboundDepartAirport = event.airport.iata_code
            }
        },
        toggleFilter: function() {
            this.filterEnabled = !this.filterEnabled
        },
        toggleFlightOptions: function() {
            this.showFlightOptions = !this.showFlightOptions
        },
        selectFlight: function(input) {
            this.selectedIndex = input.index
            this.selectedFlight = input.result
          this.baggageOptions = ''
        },
        setFlightTotalPax: function() {
            let cabin = this.payload.cabins
            let totalAdults = 0
            let totalKids = 0
            let totalInfants = 0
            if (!this.totalAdults && !this.totalKids && !this.totalInfants) {
                cabin.map(function(cab) {
                    if (cab.volwassenen > 0) {
                        totalAdults = totalAdults + parseInt(cab.volwassenen)
                    }
                    if (cab.kinderen > 0) {
                        totalKids = totalKids + parseInt(cab.kinderen)
                    }
                    if (cab.baby > 0) {
                        totalInfants = totalKids + parseInt(cab.baby)
                    }
                })
                this.totalAdults = totalAdults
                this.totalKids = totalKids
                this.totalInfants = totalInfants
            }
        },
        getflights: function() {
            let cruiseID = parseInt(this.$route.params.dossierID)
            this.selectedFlight = null
            if (Number.isInteger(cruiseID) && cruiseID > 0) {
                this.$store.dispatch('loadFlightsForDossier', {
                    dossierID: cruiseID,
                    findOutboundDepartAirport: this.findOutboundDepartAirport,
                    findOutboundArriveDate: this.findOutboundArriveDate,
                    findOutboundArriveAirport: this.findOutboundArriveAirport,
                    findInboundDepartDate: this.findInboundDepartDate,
                    findInboundDepartAirport: this.findInboundDepartAirport,
                    findInboundArriveAirport: this.findInboundArriveAirport,
                    findEmbarkTime: this.findEmbarkTime,
                    findDisembarkTime: this.findDisembarkTime,
                    returnAllAirports: this.returnAllAirports,
                    returnAirports: this.returnAirports,
                    seekDatabase: this.seekDatabase,
                    seekTransavia: this.seekTransavia,
                    seekAirTrade: this.seekAirTrade,
                    seekAmadeus: this.seekAmadeus,
                    nonStopOnly: this.nonStopOnly,
                    flightClass: this.flightClass,
                    totalAdults: this.totalAdults,
                    totalKids: this.totalKids,
                    totalInfants: this.totalInfants,
                })
            }
        },
      getairports: function() {
        let cruiseID = parseInt(this.$route.params.dossierID)
        this.selectedFlight = null
        this.$store.dispatch('loadAirportsForDossier', {
          dossierID: cruiseID,
          findOutboundDepartAirport: this.findOutboundDepartAirport,
          findOutboundArriveDate: this.findOutboundArriveDate,
          findOutboundArriveAirport: this.findOutboundArriveAirport,
          findInboundDepartDate: this.findInboundDepartDate,
          findInboundDepartAirport: this.findInboundDepartAirport,
          findInboundArriveAirport: this.findInboundArriveAirport,
          findEmbarkTime: this.findEmbarkTime,
          findDisembarkTime: this.findDisembarkTime,
          returnAllAirports: this.returnAllAirports,
          returnAirports: this.returnAirports,
          seekDatabase: this.seekDatabase,
          seekTransavia: this.seekTransavia,
          seekAirTrade: this.seekAirTrade,
          seekAmadeus: this.seekAmadeus,
          nonStopOnly: this.nonStopOnly,
          flightClass: this.flightClass
        })
      },
        addFlightsToDossier: function() {
            this.isHidden = true
            this.$store.dispatch('saveFlightsForDossier', this.selectedFlight)
        },


      selectFlightWithFares: function(fareOption) {
        this.selectedFlight.fareOption = fareOption
        this.isHidden = true
        this.$store.dispatch('saveFlightsForDossier', this.selectedFlight)
      },

      checkFareOptionsForFlights: function() {
          self = this
        self.baggageOptions = null
        self.waitingForBaggage = true;

        self.waiting = true
        self.payload = Object
        self.payload.action = 'getBaggageOptions'
        self.payload.airTradeResult = this.selectedFlight.resultListIdentifier
        self.payload.airTradeGroup = this.selectedFlight.Identifier
        self.payload.flightOutbound = this.selectedFlight.outbound[0]
        self.payload.flightInbound = this.selectedFlight.inbound[0]

        $.ajax({
          url: '/paginas/boeken2/ajax.php',
          method: 'GET',
          data: self.payload,
          success: function(responseData) {
            self.waiting = false
            if (!self.error) {
              self.waitingForBaggage = false
              self.baggageOptions = responseData
            }

          },
          error: function(error) {
            self.waiting = false
            self.$store.dispatch('saveLog', error)
          },
        })
      }
    },
    mounted: function() {
      this.getairports()

    if( parseInt(this.$route.params.dossierID) > 1) {
      this.getflights()
    }


    },
}
</script>

<style scoped>
.row1 p {
    padding-top: 10px;
    width: calc(80% - 20px);
    text-align: right;
}
.groot-button {
    padding: 10px;
    max-width: 90%;
    text-transform: uppercase;
    border: 1px solid gray;
    margin: 10px auto;
}
.green {
  color: limegreen;
}
.red {
  color: orangered;
  text-decoration: line-through;
}
.button {
    width: 50%;
    margin: 10px auto;
}

.groot-button:hover {
    background: darkorange;
    cursor: pointer;
}

input,
select {
    padding: 10px;
    width: 100%;
    margin-bottom: 10px;
}

input[type='checkbox'],
button {
    width: 20px;
}

.orange {
    background: orange;
    color: white !important;
}

.width50 {
    width: calc(50% - 20px);
    padding: 10px;
}

.width20 {
    float: left;
    width: calc(100% / 6 - 20px);
    padding: 10px;
}

.row1 {
    width: 100%;
    float: left;
    display: flex;
}

.row1 .item {
    width: calc(80% / 2 - 20px);
    padding: 10px;
}
.prijs {
    max-width: 10%;
}

.flights {
    display: flex;
    width: 100%;
    flex-flow: column;
    justify-content: space-evenly;
}
.flightsadded {
    width: calc(50% - 22px);
    margin: auto;
    text-align: center;
    font-weight: bold;
    color: darkgreen;
    padding: 10px;
    border: 1px solid green;
    background: lightgreen;
}
</style>
